module.exports = __webpack_public_path__ + "img/1.0093fb0d.png";